webpackJsonp([162898551421021],{

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    "section",
	    { className: "site-page" },
	    _react2.default.createElement(
	      "header",
	      { className: "site-page--header" },
	      _react2.default.createElement(
	        "h1",
	        { className: "site-page--title" },
	        "Oooops!"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "The page you are looking for does not exist."
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-420b1828be02085721d9.js